import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.primary.main,
    fontFamily: 'Dazzed',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px'
  }
}))

const DazzedHeading14 = ({ id, className, children, regular, semibold, style = {} }) => {
  const classes = useStyles({})

  return (
    <div
      id={id}
      className={[classes.heading, className].join(' ')}
      style={{ fontWeight: regular ? 400 : semibold ? 500 : 600, ...style }}
    >
      {children}
    </div>
  )
}

export default DazzedHeading14
